import { render, staticRenderFns } from "./pre_tan.vue?vue&type=template&id=5653c9cf&scoped=true"
import script from "./pre_tan.vue?vue&type=script&lang=js"
export * from "./pre_tan.vue?vue&type=script&lang=js"
import style0 from "./pre_tan.vue?vue&type=style&index=0&id=5653c9cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5653c9cf",
  null
  
)

export default component.exports